<template>
  <div class="">
    <div class="header">
      <h2 class="">{{ title }}</h2>
    </div>

    <draggable class="inner" :list="items" group="notes">
      <div
        class="list-group-item item relative"
        v-for="(element, index) in items"
        :key="`${titlelc}-${getTime()}-${index}`"
      >
        <h2
          v-html="element.title"
          v-if="element.type == 'headline'"
          class="subtitle-2"
        ></h2>
        <p v-html="element.title" v-else class="content" :class="element.color"></p>
      </div>
    </draggable>

  

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'addContent'">
        <v-card-title>Add content</v-card-title>

        <v-card-text>
          <v-textarea
            color="amber"
            v-model="newNote"
            :rows="1"
            :autoGrow="true"
            :hide-details="true"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn @click="addContent" color="amber">Save</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "UserArchitectureItems",
  data() {
    return {
      newTitle: this.title,
      newNote: "",
      dialog: false,
      dialogMode: "",
      deleteObj: null,
    };
  },
  props: {
    title: String,
    items: Array,
    name: String,
  },
  components: {
    draggable,
  },
  computed: {
    titlelc() {
      return this.title.toLowerCase();
    },
  },
  methods: {
    getTime() {
      return Math.round(new Date().getTime() / 1000);
    },
  },
};
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}
  </style>
